import { Body, Close, Description, Footer, Header, Root, Title } from "./adaptive-modal";

/**
 * AdaptiveModal — viewport-adaptive overlay organism, the default overlay
 * surface for the app.
 *
 * Renders a Dialog on tablet/desktop and a BottomSheet on mobile behind one
 * compound API:
 *
 *   <AdaptiveModal.Root open onOpenChange dialogSize bottomSheetDetents>
 *     <AdaptiveModal.Header>
 *       <AdaptiveModal.Title /> <AdaptiveModal.Description />
 *     </AdaptiveModal.Header>
 *     <AdaptiveModal.Body />
 *     <AdaptiveModal.Footer> <AdaptiveModal.Close /> </AdaptiveModal.Footer>
 *   </AdaptiveModal.Root>
 *
 * For overlays opened from outside the React tree, use `openModalSheet` /
 * `openModal` and mount `ModalHost` once at the app root.
 */
export const AdaptiveModal = {
  Root,
  Header,
  Title,
  Description,
  Body,
  Footer,
  Close,
};

export { ModalHost } from "./modal-host";
export { closeAllModals, closeModal, openModal, openModalSheet, useModalEntries } from "./store";
export type {
  AdaptiveModalBodyProps,
  AdaptiveModalCloseProps,
  AdaptiveModalDescriptionProps,
  AdaptiveModalFooterProps,
  AdaptiveModalHeaderProps,
  AdaptiveModalRootProps,
  AdaptiveModalTitleProps,
  GlobalModalProps,
  ModalEntry,
  ModalRenderProps,
} from "./types";
